/**
 * Transporte hacia el host. Web: objeto por postMessage (el shell hace dataLayer.push).
 * App: string JSON por ReactNativeWebView (ENA-1803 lo mapea a Firebase). Si ambos
 * existen, los dos reciben el mismo payload.
 */
import type { DataLayerPush } from '../analytics/paymentAnalytics';
import { registerAnalyticsTransport } from '../analytics/paymentAnalytics';
import { PAYMENT_IFRAME_MESSAGE_SOURCE } from './reportFrameHeight';

export const ANALYTICS_MESSAGE_TYPE = 'analytics';

let installed = false;

export function postAnalyticsToHost(push: DataLayerPush): void {
  const message = {
    source: PAYMENT_IFRAME_MESSAGE_SOURCE,
    type: ANALYTICS_MESSAGE_TYPE,
    payload: { dataLayerPush: push },
  };
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, '*');
  }
}

export function installHostAnalyticsTransport(): void {
  if (installed) return;
  installed = true;
  registerAnalyticsTransport({ id: 'host', send: postAnalyticsToHost });
}

/** El host responde con `analytics-context` (el postMessage de carga puede llegar antes del listener). */
export function notifyAnalyticsReady(): void {
  const message = { source: PAYMENT_IFRAME_MESSAGE_SOURCE, type: 'analytics-ready' };
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, '*');
  }
}
